import { render, staticRenderFns } from "./agentCreate.vue?vue&type=template&id=31ed9a3a&scoped=true&lang=html&"
import script from "./agentCreate.vue?vue&type=script&lang=js&"
export * from "./agentCreate.vue?vue&type=script&lang=js&"
import style0 from "./agentCreate.vue?vue&type=style&index=0&id=31ed9a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed9a3a",
  null
  
)

export default component.exports